import constants from '#packages/constants';
export default constants.TEXT_CONTROLS;
